import { SONHTMLContent } from '../Wysiwyg';
import { UserProfile } from '../../../types/api/UserProfile';
import { IFileItem } from '../../../types/api/FileItem';
import { HiddenParam, RichTextParam, SonForm } from '../../Form2';
import { AnyParameter } from '../../Form2/types/SonForm';
import { BlockType } from '../../../types/api/ElementType';
import { PostFlagInappropriateForm } from './forms/PostFlagInappropriateModal';
import { PostDeleteForm } from './forms/PostDeleteModal';
import { PostUpdateForm } from './forms/PostUpdateForm';
import { PostEditorForm } from './editors/PostsEditor';

export type PostFirstTypes = 'comment' | 'thread' | 'feedback';
export type PostTypes = PostFirstTypes | 'reply';

export type PostReplyForm = SonForm<RichTextParam<'content'> | HiddenParam<'replyTo'>>;

// a PostReply is the same as a Post, but it cant have attachments and replies
// export type PostReply = Omit<PostFirst, 'replies' | 'attachments' | 'attachedFileUpdateOrder' | 'replyForm'>;
export type PostReply = SONHTMLContent & {
  id: string;
  createDate: string;
  author: UserProfile;
  updateForm?: PostUpdateForm;
  deleteForm?: PostDeleteForm;
  flagInappropriateForm?: PostFlagInappropriateForm;
  flaggedInappropriate?: boolean;
  editDate?: string;
};
export type PostFirst = PostReply & {
  replyForm: PostReplyForm;
  replies?: PostReply[];
  attachments?: IFileItem[];
  attachedFileUpdateOrder?: SonForm<AnyParameter>;
};

export type PostBlockTypes = BlockType.comments | BlockType.thread | BlockType.threadlist | BlockType.editorFeedback;

export const postType = (
  elementType: BlockType.comments | BlockType.thread | BlockType.threadlist | BlockType.editorFeedback
) => {
  if (elementType === BlockType.editorFeedback) {
    return 'feedback';
  } else {
    return 'comment';
  }
};

export function isPostFirst(post: PostFirst | PostReply): post is PostFirst {
  const postFirst = post as PostFirst;
  return !!postFirst.replyForm;
}

export type PostForm = PostReplyForm | PostDeleteForm | PostUpdateForm | PostEditorForm | PostFlagInappropriateForm;

export function isDeleteForm(
  form: PostForm | undefined,
  deleteForm: PostDeleteForm | undefined
): form is PostDeleteForm {
  return !!form && form === deleteForm;
}

export function isUpdateForm(
  form: PostForm | undefined,
  updateForm: PostUpdateForm | undefined
): form is PostUpdateForm {
  return !!form && form === updateForm;
}

export function isFlagInappropriateForm(
  form: PostForm | undefined,
  flagInappropriateForm: PostFlagInappropriateForm | undefined
): form is PostFlagInappropriateForm {
  return !!form && form === flagInappropriateForm;
}
